import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { validationClasses } from '@/utils/errors';
import fields from '@/constants/fields';

const listItems = (items) => items.map((item) => ({
  key: `cohort_filter_item_${item}`,
  text: item,
  value: item,
}));

const CohortFilterValuesDropdown = ({
  filterUUID,
  saveErrors,
  values,
  disabled,
  onChange,
}) => {
  const intl = useIntl();
  const validationError = saveErrors.find((e) => (
    e.context.filterUUID === filterUUID && e.fields.includes(fields.VALUE)));

  return (
    <Dropdown
      fluid
      search
      selection
      multiple
      allowAdditions
      className={validationClasses(validationError, 'aridhia-cohort-filter-values-dropdown')}
      value={values}
      options={listItems(values)}
      disabled={disabled}
      placeholder={intl.formatMessage({ id: 'cohort.filter.array.placeholder' })}
      noResultsMessage={intl.formatMessage({ id: 'cohort.filter.array.placeholder' })}
      onChange={(e, { value }) => { onChange(value); }}
    />
  );
};

export default CohortFilterValuesDropdown;
